import { useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  TextField,
} from "@mui/material";
import {
  getInputLabelProps,
  getInputProps,
  PopperFullWidth,
} from "../../../common/appStyles";
import localize from "../../../common/localize";
import Combobox from "../../../components/common/Combobox";
import { getPaymentTypeOptions } from "../../../common/EntitiesManagement";
import { MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION } from "../../../common/utils";
import CreatedByText from "../../../components/common/CreatedByText";

export default function AddOrEditPaymentType({ model, setModel }) {
  const [descriptionCount, setDescriptionCount] = useState(0);
  const maximumCharactersForDescription =
    MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION;
  const paymentTypes = getPaymentTypeOptions();

  useEffect(() => {
    if (model.Description) {
      setDescriptionCount(model.Description.length);
    }
  }, [model?.Description]);

  const handlePaymentTypeChange = (e) => {
    setModel({
      ...model,
      Type: e.Id ?? paymentTypes[0].Id,
      TypeModel: e ?? paymentTypes[0],
      DefaultValue:
        e.Id === 1 && model.DefaultValue > 100 ? 100 : model.DefaultValue,
    });
  };

  const handleChange = (e) => {
    if (e.target.name === "DefaultValue") {
      setModel({
        ...model,
        [e.target.name]:
          model.Type === 1
            ? parseInt(e.target.value) > 100
              ? 100
              : parseInt(e.target.value) < 0
              ? 0
              : e.target.value
            : e.target.value,
      });
      return;
    }

    setModel({
      ...model,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckedChanged = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.checked,
    });
  };

  return (
    <div style={{ width: "100%" }}>
      <form className="w-full">
        <div className="flex flex-wrap mb-3 mt-2">
          <FormControl required fullWidth>
            <TextField
              required
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              id="outlined-basic"
              name="Name"
              label={localize.name}
              variant="outlined"
              onChange={handleChange}
              value={model.Name}
            />
          </FormControl>
        </div>

        <div className="flex mb-3 gap-2 items-center">
          <div style={{ width: "60%" }}>
            <Combobox
              isRequired
              fullwidth
              id="paymentType"
              fieldLabel={localize.payment_method}
              fieldOptions={paymentTypes ?? []}
              fieldValue={model?.TypeModel}
              handleValueChange={handlePaymentTypeChange}
              popperFullWidth={PopperFullWidth}
            />
          </div>

          <div style={{ width: "40%" }}>
            <TextField
              type="number"
              InputLabelProps={getInputLabelProps()}
              inputProps={{
                ...getInputProps(),
                min: model?.Type === 1 ? 0 : undefined,
                max: model?.Type === 1 ? 100 : undefined,
              }}
              value={model.DefaultValue}
              onChange={handleChange}
              size="small"
              id="Defaultvalue"
              name="DefaultValue"
              label={localize.default_value}
              variant="outlined"
              fullWidth
            />
          </div>
        </div>

        <div className="flex flex-wrap mb-3">
          <FormControl required fullWidth>
            <TextField
              InputLabelProps={getInputLabelProps()}
              inputProps={{
                style: {
                  fontSize: "0.8em",
                },
                maxLength: maximumCharactersForDescription,
              }}
              size="small"
              fullWidth
              multiline
              rows={6}
              id="outlined-basic"
              name="Description"
              label={localize.description}
              variant="outlined"
              onChange={handleChange}
              value={model.Description}
              helperText={`${descriptionCount}/${maximumCharactersForDescription}`}
            />
          </FormControl>
        </div>

        <div className="w-full">
          <FormControlLabel
            size="small"
            name="NeedObservation"
            control={
              <Checkbox
                size="small"
                name="NeedObservation"
                checked={model.NeedObservation}
                onChange={handleCheckedChanged}
              />
            }
            label={
              <span style={{ fontSize: "0.8em" }}>
                {localize.need_observation}
              </span>
            }
          />
        </div>
      </form>

      <CreatedByText entity={model} />
    </div>
  );
}
